import React from 'react';

const Legend: React.FC = () => (
  <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">
    <span className="font-medium">Legend:</span> G = Goals, A = Assists, xG = Expected Goals,
    Sh = Shots, SoT = Shots on Target, Pass = Total Passes, Cmp = Completed Passes,
    KP = Key Passes, Duel = Total Duels, Won = Duels Won, Int = Interceptions, Rec = Recoveries
  </div>
);

export default Legend;
